var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 74,
    viewBox: "0 0 77 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 72.9723C59.867 72.9723 75.9723 56.867 75.9723 37.0001C75.9723 17.1331 59.867 1.02783 40.0001 1.02783C20.1331 1.02783 4.02783 17.1331 4.02783 37.0001C4.02783 56.867 20.1331 72.9723 40.0001 72.9723Z",
    fill: "#2D1B00",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 72.9723C59.867 72.9723 75.9723 56.867 75.9723 37.0001C75.9723 17.1331 59.867 1.02783 40.0001 1.02783C20.1331 1.02783 4.02783 17.1331 4.02783 37.0001C4.02783 56.867 20.1331 72.9723 40.0001 72.9723Z",
    fill: "url(#paint0_linear_orange)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -9,
    y: -12,
    width: 98,
    height: 98
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_0_743_3187_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3187)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 74C60.4345 74 77 57.4345 77 37C77 16.5655 60.4345 0 40 0C19.5655 0 3 16.5655 3 37C3 57.4345 19.5655 74 40 74Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 74C60.4345 74 77 57.4345 77 37C77 16.5655 60.4345 0 40 0C19.5655 0 3 16.5655 3 37C3 57.4345 19.5655 74 40 74Z",
    fill: "url(#paint1_linear_orange)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0.5C60.1584 0.5 76.5 16.8416 76.5 37C76.5 57.1584 60.1584 73.5 40 73.5C19.8416 73.5 3.5 57.1584 3.5 37C3.5 16.8416 19.8416 0.5 40 0.5Z",
    stroke: "url(#paint2_linear_orange)",
    strokeOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_743_3187)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2176,
    cy: 38.8808,
    rx: 14.4138,
    ry: 24.1706,
    transform: "rotate(-84.1811 38.2176 38.8808)",
    fill: "url(#paint3_linear_orange)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6533 19.5801C34.1341 19.3119 34.7381 19.4283 35.084 19.8565C35.4151 20.3184 35.3233 20.9598 34.876 21.3106L25.4385 27.9561H54.7197L45.1904 21.333C45.1727 21.3217 45.1548 21.3103 45.1377 21.2979C44.6843 20.9684 44.5839 20.3335 44.9131 19.8799C45.2872 19.449 45.9098 19.3337 46.4131 19.6026L58.3193 27.9561H62.5654C62.5971 27.9553 62.6286 27.9559 62.6602 27.958C63.2323 27.9964 63.6655 28.4913 63.627 29.0635V49.3457C63.6141 49.919 63.1387 50.3731 62.5654 50.3604H17.4092C16.842 50.3253 16.3927 49.8666 16.3701 49.2988V29.0166C16.3929 28.449 16.8421 27.9911 17.4092 27.9561H21.8389L33.6533 19.5801ZM49.7129 34.9473C49.1452 34.9699 48.6865 35.4182 48.6514 35.9854V42.4004C48.6361 42.5037 48.6361 42.6086 48.6514 42.7119C48.7376 43.2918 49.2776 43.6927 49.8574 43.6065C50.4372 43.5202 50.8372 42.9802 50.751 42.4004L50.7744 35.9854C50.7393 35.4184 50.2805 34.97 49.7129 34.9473ZM36.8369 34.9473C36.2636 34.9476 35.7987 35.412 35.7988 35.9854V42.4942C35.8249 43.0543 36.3004 43.4879 36.8604 43.4619C37.4413 43.4497 37.9095 42.9813 37.9219 42.4004V35.9854C37.8868 35.4182 37.4281 34.9699 36.8604 34.9473C36.8526 34.9472 36.8446 34.9473 36.8369 34.9473ZM43.2754 34.9473C42.703 34.959 42.2381 35.4134 42.2139 35.9854V42.4004C42.214 42.9864 42.6892 43.4619 43.2754 43.4619C43.8562 43.4496 44.3246 42.9812 44.3369 42.4004V35.9854C44.3018 35.4183 43.843 34.97 43.2754 34.9473ZM56.1045 34.9473C55.5368 34.9699 55.0781 35.4182 55.043 35.9854V42.4004C55.0553 42.9813 55.5235 43.4497 56.1045 43.4619C56.1359 43.4634 56.1678 43.4634 56.1992 43.4619C56.7592 43.4357 57.1919 42.9604 57.166 42.4004V35.9619C57.1532 35.3888 56.6777 34.9346 56.1045 34.9473ZM23.9619 34.9697C23.4012 34.9697 22.9463 35.4247 22.9463 35.9854V42.4004C22.9464 42.961 23.4013 43.4151 23.9619 43.4151C24.5225 43.415 24.9774 42.961 24.9775 42.4004V35.9854C24.9775 35.4247 24.5226 34.9698 23.9619 34.9697ZM30.374 34.8799C29.8019 34.9183 29.3691 35.4133 29.4072 35.9854V42.4004C29.4074 42.961 29.8622 43.4151 30.4229 43.4151C30.9834 43.415 31.4374 42.9609 31.4375 42.4004V35.916C31.4266 35.3648 30.9955 34.9139 30.4453 34.8779C30.4216 34.8778 30.3977 34.8783 30.374 34.8799ZM49.0439 1.02736C49.62 1.05096 50.0817 1.51293 50.1055 2.08889V5.13478C50.0825 5.40778 49.9587 5.66316 49.7588 5.8506L44.5439 11.0654C44.3309 11.2826 44.0405 11.4068 43.7363 11.4112H41.083V13.7422C41.0702 14.3154 40.5948 14.7696 40.0215 14.7569C38.7473 14.7571 37.7149 15.7903 37.7148 17.0645C37.7148 18.3769 38.7784 19.4413 40.0908 19.4414C41.4034 19.4414 42.4678 18.377 42.4678 17.0645C42.4677 17.0567 42.4678 17.0488 42.4678 17.041C42.4679 16.4677 42.9325 16.0029 43.5059 16.0029C44.082 16.0264 44.5438 16.4883 44.5674 17.0645C44.5674 19.5368 42.5631 21.541 40.0908 21.541C37.6186 21.541 35.6143 19.5366 35.6143 17.0645C35.6018 15.0242 36.9986 13.2449 38.9834 12.7725V11.5039H36.3066C36.0337 11.481 35.7792 11.3571 35.5918 11.1572L30.377 5.9424C30.1771 5.7551 30.0532 5.5005 30.0303 5.22756V2.04299C30.0431 1.46969 30.5185 1.0146 31.0918 1.02736H49.0439Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_743_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6956 5.13892V8.86579C63.9622 12.6841 68.7997 18.425 71.473 25.2163C74.1464 32.0075 74.5095 39.4778 72.5072 46.4921C70.5049 53.5065 66.2466 59.6815 60.3793 64.0789C54.5121 68.4764 47.3566 70.8558 40 70.8558C32.6434 70.8558 25.4879 68.4764 19.6207 64.0789C13.7534 59.6815 9.49515 53.5065 7.49283 46.4921C5.49052 39.4778 5.85362 32.0075 8.52696 25.2163C11.2003 18.425 16.0378 12.6841 22.3044 8.86579V5.13892C15.082 9.03628 9.37577 15.2069 6.08713 22.676C2.79849 30.1451 2.11485 38.487 4.1442 46.384C6.17354 54.2811 10.8002 61.2831 17.2934 66.2841C23.7865 71.2851 31.7761 74 40 74C48.2239 74 56.2135 71.2851 62.7066 66.2841C69.1998 61.2831 73.8265 54.2811 75.8558 46.384C77.8852 38.487 77.2015 30.1451 73.9129 22.676C70.6242 15.2069 64.918 9.03628 57.6956 5.13892Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3187",
    x: -9,
    y: -12,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3187"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_743_3187_clip_path",
    transform: "translate(9 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 74C60.4345 74 77 57.4345 77 37C77 16.5655 60.4345 0 40 0C19.5655 0 3 16.5655 3 37C3 57.4345 19.5655 74 40 74Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_743_3187",
    x: 0.126465,
    y: 10.3311,
    width: 76.1824,
    height: 57.0994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_743_3187"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3187",
    x: 16.3701,
    y: 1.0271,
    width: 47.2593,
    height: 53.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3187"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_743_3187",
    x: 3,
    y: 5.13892,
    width: 74,
    height: 70.8611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3187"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_orange",
    x1: 4.02783,
    y1: 1.02783,
    x2: 88.7762,
    y2: 22.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#FF4E50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_orange",
    x1: 3,
    y1: 0,
    x2: 90.1697,
    y2: 22.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#F7971E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_orange",
    x1: 5.3125,
    y1: 3.36364,
    x2: 77,
    y2: 3.36364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FF4B1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_orange",
    x1: 36.5988,
    y1: 39.0368,
    x2: 51.1662,
    y2: 48.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF512F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09819"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon02);
export default __webpack_public_path__ + "static/media/service-icon02.9fe6fa6e99e2c33eb670ade1133f11c2.svg";
export { ForwardRef as ReactComponent };